module.exports = __webpack_public_path__ + "media/חסה.dc22ed68.mp3";